<div class="mainContainer">
  @if (module) {
    <div class="title">
      {{ module.title }}
    </div>
  }
  <div class="questionIndicator">
    @for (question of questions; track question; let i = $index) {
      <div class="questionMark" [ngStyle]="getDimensionsForIndicators(i)" [class.passed]="qIndex !== undefined && i < qIndex"></div>
    }
  </div>
  @if (qIndex !== undefined && questions[qIndex].question_type === QuestionType.quizz) {
    <div class="questionContainer">
      <q-quizz [question]="questions[qIndex]" [graphism]="graphism ?? 'vectoriel'" [(pickedAnswers)]="pickedQuizzAnswers" #quizz></q-quizz>
    </div>
  }
  @if (qIndex !== undefined && questions[qIndex].question_type === QuestionType.jeuFleche) {
    <div class="questionContainer">
      <q-jeufleche [question]="questions[qIndex]" [(pickedAnswers)]="pickedJeuFlecheAnswers" #jeufleche></q-jeufleche>
    </div>
  }
  @if (qIndex !== undefined && questions[qIndex].question_type === QuestionType.goNogo) {
    <div class="questionContainer">
      <q-gonogo [question]="questions[qIndex]" [validate]="validate" [(pickedAnswers)]="pickedQuizzAnswers" #gonogo></q-gonogo>
    </div>
  }
  @if (qIndex !== undefined && questions[qIndex].question_type === QuestionType.resistanceCognitive) {
    <div class="questionContainer">
      <q-cogres [question]="questions[qIndex]" [validate]="validate" [(pickedAnswers)]="pickedQuizzAnswers" #cogres></q-cogres>
    </div>
  }
  @if (qIndex !== undefined && questions[qIndex].question_type === QuestionType.puzzleDePhrase) {
    <div class="questionContainer">
      <q-puzzle [question]="questions[qIndex]" [(pickedAnswer)]="pickedPuzzleAnswer" #puzzle></q-puzzle>
    </div>
  }
  @if (qIndex !== undefined && questions[qIndex].question_type === QuestionType.texteATrous) {
    <div class="questionContainer">
      <q-trous [question]="questions[qIndex]" [(pickedAnswer)]="pickedPuzzleAnswer" #trous></q-trous>
    </div>
  }
  @if (qIndex !== undefined && questions[qIndex].question_type === QuestionType.simulation) {
    <div class="questionContainer">
      <q-simulation [question]="questions[qIndex]" [graphism]="graphism ?? 'vectoriel'" (simulationComplete)="onSimulationComplete($event)" #simulation></q-simulation>
    </div>
  }
</div>
@if (shouldDisplayValidateButton()) {
  <div class="validateButtonContainer">
    <div class="validateButton ctaBtn" (click)="validate()" [ngStyle]="getStyleForValidateButton()">
      @if (viewMode === QuestionViewMode.question) {
        <i class="bi bi-check"></i>
      }
      <div>{{ 'moduleCompletion.validate' | translate }}</div>
    </div>
  </div>
}
@if (shouldDisplayNextButton()) {
  <div class="validateButtonContainer">
    <div class="validateButton ctaBtn" (click)="next()" [ngStyle]="getStyleForValidateButton()">
      @if (viewMode === QuestionViewMode.answer) {
        <i class="bi bi-arrow-right-short"></i>
      }
      <div>{{ 'moduleCompletion.next' | translate }}</div>
    </div>
  </div>
}
<div class="correctionOverlay" [@overlayAnimation]="showCorrection ? 'visible' : 'hidden'" [style.display]="viewMode === QuestionViewMode.answer ? 'block' : 'none'"></div>
@if (viewMode === QuestionViewMode.answer && !isLoadingAnswer) {
  <div class="correctionContainer">
    <correction [correction]="corrections" [onlyPicked]="onlyPicked" [isVisible]="showCorrection"></correction>
  </div>
}
